import SideNavItem from '../SideNavItem/SideNavItem';
// import { useCategories } from '@/store';
import { getIcon } from '@/Icons';
import { getCategories } from '@/backend/casino/get-categories/server-side-rendered';
import SectionTitle from '../SectionTitle/SectionTitle';

const language = 'EN';
const CasinoCategories = async () => {
	const categories = await getCategories();

	if (!categories) {
		return null;
	}

	return (
		<>
			<SectionTitle title="Casino" />
			{categories?.map((category, index) => (
				<SideNavItem
					key={index}
					title={category.name?.[language]?.toLowerCase().split('-').join(' ')}
					link={`/casino/category/${category.name?.[language]?.toLowerCase().split(' ').join('-')}`}
					icon={getIcon(category.iconKey)}
				/>
			))}
			<SideNavItem
				title={'Providers'}
				link={`/providers`}
				icon={getIcon('providers')}
			/>
		</>
	);
};

export default CasinoCategories;
